import { render, staticRenderFns } from "./SfdStatCard.vue?vue&type=template&id=47c8be20&scoped=true"
import script from "./SfdStatCard.vue?vue&type=script&lang=ts"
export * from "./SfdStatCard.vue?vue&type=script&lang=ts"
import style0 from "./SfdStatCard.vue?vue&type=style&index=0&id=47c8be20&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c8be20",
  null
  
)

export default component.exports